import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';

const sectionsProductListConfig: ProductListConfig = {
  cardsSubtitle: 'communicatedSizeText',
  mobileCardText: 'communicatedSizeText',
  categories: [
    {
      id: 'sections-40',
      categoryTitle:
        'storageone.depth communicatedDimensionsLocalized.depth communicatedDimensionsLocalized.unit',
      products: [
        { path: 'type', value: ProductType.ELVARLI_SECTION },
        { path: 'communicatedDimensions.depth', value: 360 }
      ]
    },
    {
      id: 'sections-50',
      categoryTitle:
        'storageone.depth communicatedDimensionsLocalized.depth communicatedDimensionsLocalized.unit',
      products: [
        { path: 'type', value: ProductType.ELVARLI_SECTION },
        { path: 'communicatedDimensions.depth', value: 510 }
      ]
    }
  ],
  behaviors: {
    productClicked: [addProduct],
    productDropped: [addProduct]
  },
  cluster: [],
  sortOrder: []
};

export default sectionsProductListConfig;
